import { fromJS } from 'immutable';
import createAction from 'utils/redux-helpers/createAction';

const handler = (state, { path, data }) => state.setIn(path, fromJS(data));

export const setData = createAction({
  action: ['setData', 'path', 'data'],
  handler,
});
